import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import side from '@/components/web/content/side.vue';
import Product from '@/components/web/content/Product.vue';
import ContentProduct from '@/components/web/content/ContentProduct.vue';



export default /*@__PURE__*/_defineComponent({
  __name: 'CaseStudiesView',
  props: {
    title: {},
    imageList: { default: () => [] },
    productInfo: {},
    contentWithImg: { default: () => ({
            h2Title: '',
            pList: [],
            img: []
        }) },
    productCollection: { default: () => [] },
    advantageProps: { default: () => ({
            h2Title: "Our Parts Manufacturing Advance Capability",
            pTitle: "Our molds are processed independently, without additional profit, moderate cost, short cycle, and sample out at the fastest 20 days, and all our company's ex-factory die-casting parts and unqualified products are returned and exchanged unconditionally without reason."
        }) },
    advantageCollection: {},
    viewadvantageCollection: {},
    viewPartsCollection: {},
    honorCertificatesCollection: {},
    dieCastingWorkshopCollection: {}
  },
  setup(__props: any) {

const props = __props;



return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createBlock(_component_el_row, { gutter: 30 }, {
    default: _withCtx(() => [
      _createVNode(_component_el_col, {
        xs: 24,
        sm: 24,
        md: 18,
        lg: 18,
        xl: 18
      }, {
        default: _withCtx(() => [
          _createVNode(Product, {
            title: _ctx.title,
            "image-list": _ctx.imageList,
            "product-info": _ctx.productInfo
          }, null, 8, ["title", "image-list", "product-info"]),
          _createVNode(ContentProduct, {
            "advantage-collection": _ctx.advantageCollection,
            "view-parts-collection": _ctx.viewPartsCollection,
            "viewadvantage-collection": _ctx.viewadvantageCollection,
            contentWithImg: _ctx.contentWithImg,
            "product-collection": _ctx.productCollection,
            "advantage-props": _ctx.advantageProps,
            "honor-certificates-collection": _ctx.honorCertificatesCollection,
            "die-casting-workshop-collection": _ctx.dieCastingWorkshopCollection
          }, null, 8, ["advantage-collection", "view-parts-collection", "viewadvantage-collection", "contentWithImg", "product-collection", "advantage-props", "honor-certificates-collection", "die-casting-workshop-collection"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_col, {
        xs: 24,
        sm: 24,
        md: 6,
        lg: 6,
        xl: 6
      }, {
        default: _withCtx(() => [
          _createVNode(side)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})